module.exports = __webpack_public_path__ + "img/Green_Mixed.69cc8de8.png";